import { useMutation } from '@tanstack/react-query'

import { createReservation } from '../request/reservationApis'

import type { ICreateReservationRequest, IReservation } from '../../model'
import type { AxiosError } from 'axios'

const useCreateReservationMutation = ({
  onSuccess,
  onError,
}: {
  onSuccess?: (reservation: IReservation) => void
  onError?: (error: AxiosError) => void
}) => {
  return useMutation({
    mutationFn: (requestBody: ICreateReservationRequest) =>
      createReservation(requestBody),
    onSuccess,
    onError,
    throwOnError: false,
  })
}

export default useCreateReservationMutation
